import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import Loading from './Loading';
import { oktaEnabled } from './config';


const SecureRoute = ({ element, redirectTo }) => {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {

    const redirectToLogin = async () => {
      if (authState && !authState.isAuthenticated) {
        await oktaAuth.signInWithRedirect({ originalUri: redirectTo || "/" });
      }
    };

    oktaEnabled && redirectToLogin();
  }, [authState, oktaAuth, redirectTo]);

  // Render element if okta not used
  if (!oktaEnabled)
    return element;

  // If the user is authenticated, render the element; otherwise, show loading message
  return authState?.isAuthenticated ? element : <Loading text='Checking authentication...'></Loading>;
};

export default SecureRoute;